/**
 * Formats a profit/loss amount for display.
 * Returns the absolute value formatted with appropriate decimal places.
 * @param profitAndLoss - The profit and loss amount (can be positive or negative).
 * @returns Formatted amount string with 0 or 2 decimal places.
 */
export const formatAmount = (profitAndLoss: number): string => {
    const absoluteAmount = Math.abs(profitAndLoss);
    return Number.isInteger(absoluteAmount) ? absoluteAmount.toFixed(0) : absoluteAmount.toFixed(2);
};
